import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { NotificationResponse } from '@/types/notification';
import type {
  WhatsAppNotificationPreference,
  WhatsAppNotificationRule,
} from '@/types/whatsappNotifications';

export const whatsappNotificationsApi = {
  list: (params?: SearchParams) =>
    unwrap(
      api.get<ApiResponse<PageResponse<NotificationResponse>>>('/v1/social/whatsapp/notifications', {
        params,
      }),
    ),

  unreadCount: () =>
    unwrap(
      api.get<ApiResponse<{ count: number }>>('/v1/social/whatsapp/notifications/unread-count'),
    ),

  markRead: (id: number) =>
    unwrap(api.post<ApiResponse<NotificationResponse>>(`/v1/social/whatsapp/notifications/${id}/read`)),

  markAllRead: () =>
    unwrap(api.post<ApiResponse<{ updated: number }>>('/v1/social/whatsapp/notifications/read-all')),

  preferences: () =>
    unwrap(
      api.get<ApiResponse<WhatsAppNotificationPreference[]>>(
        '/v1/social/whatsapp/notifications/notification-preferences',
      ),
    ),

  updatePreferences: (preferences: WhatsAppNotificationPreference[]) =>
    unwrap(
      api.put<ApiResponse<WhatsAppNotificationPreference[]>>(
        '/v1/social/whatsapp/notifications/notification-preferences',
        { preferences },
      ),
    ),

  rules: () =>
    unwrap(
      api.get<ApiResponse<WhatsAppNotificationRule[]>>(
        '/v1/social/whatsapp/notifications/notification-rules',
      ),
    ),

  updateRules: (rules: WhatsAppNotificationRule[]) =>
    unwrap(
      api.put<ApiResponse<WhatsAppNotificationRule[]>>(
        '/v1/social/whatsapp/notifications/notification-rules',
        { rules },
      ),
    ),
};
